export default __webpack_public_path__ + "static/media/placeholder_private03-it-web.9812bd8c.png";